import { Box, Button, Card, Stack, Typography } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import EditBookingModal from "./editBookingModal";
import CompleteBooking from "./completeBooking";
import EmailIcon from "@mui/icons-material/Email";
import PrintIcon from "@mui/icons-material/Print";
import { useState } from "react";
import PrintModal from "./printModal";
import InvitationCard from "./invitationCard";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EscalatorWarningIcon from "@mui/icons-material/EscalatorWarning";
import LocalPizzaIcon from "@mui/icons-material/LocalPizza";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import { convertTo12HourTimeCompact } from "../../../util/general/convertTo12HourTimeCompact";
import BadgeIcon from "@mui/icons-material/Badge";
import CompleteParty from "./completeParty";
import CancelBooking from "./cancelBooking";
import MaleIcon from "@mui/icons-material/Male";
import FemaleIcon from "@mui/icons-material/Female";
import TripBookingModal from "./fieldTripEventEditor";
import InvoiceModal from "./prinTripInvoiceModal";

const TripBookedEvent = (props) => {
  const dates =
    props.fieldTripEvent.length === 0
      ? ["All"]
      : props.fieldTripEvent
          .map((e) => e.date)
          .filter((value, index, self) => self.indexOf(value) === index)
          .sort((a, b) => a.localeCompare(b));

  const [printModal, setPrintModal] = useState(false);
  const [printData, setPrintData] = useState([]);
  const [invtCardModal, setInvtCardModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState("Upcoming");
  const [openEdit, setOpenEdit] = useState(false);

  const handleClose = () => {
    setOpenEdit(false);
  };

  const toRenderBooking =
    props.fieldTripEvent.length === 0 ? (
      <>No Pending Bookings</>
    ) : (
      <Stack sx={{ maxWidth: 800 }}>
        {props.fieldTripEvent
          .sort((a, b) => `${a.date}`.localeCompare(`${b.date}`))
          .filter((item) =>
            selectedDate == "All"
              ? dates.includes(item.date)
              : selectedDate === "Upcoming"
              ? item.date === dates[0]
              : item.date === selectedDate
          )
          .map((e) => (
            <Card
              key={e._id}
              variant="outlined"
              sx={{
                maxWidth: 400,
                marginTop: "30px",
                borderWidth: "2px",
                padding: "10px",
                paddingTop: "0",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.112)",
                "&:hover": {
                  boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.187)",
                },
              }}
            >
              <Stack direction="column" justifyContent="space-between">
                <Box>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    sx={{
                      width: "100%",
                      //   bgcolor: "#0aa014",
                      fontSize: "18px",
                      //   color: "white",
                      textAlign: "right",
                      fontWeight: "600",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #69676a7f",
                    }}
                  >
                    <Box>
                      <span style={{ color: "#b68014" }}>
                        {e.date.slice(5, 10)}
                      </span>{" "}
                      {/* <ChangeDateTime
                        eventData={e}
                        reFreshData={props.reFreshData}
                      /> */}
                    </Box>
                    <Box sx={{ ml: "10px" }}>
                      Booking#:{" "}
                      <span style={{ color: "green" }}>{e._id.slice(-6)} </span>
                    </Box>
                  </Stack>
                  <Typography
                    Typography
                    variant="h6"
                    gutterBottom
                    sx={{
                      fontWeight: "600",
                      textAlign: "center",
                      paddingY: "10px",
                      fontSize: "20px",
                    }}
                  >
                    {e.client}
                  </Typography>
                </Box>
                <Box>
                  <Typography Typography variant="subtitle1" gutterBottom>
                    Number of Children: {e.guestCount}
                  </Typography>
                  <Typography Typography variant="subtitle1" gutterBottom>
                    Contact: {e.contact}
                  </Typography>
                  <Typography Typography variant="subtitle1" gutterBottom>
                    {e.note}
                  </Typography>

                  {/* {e.items.map((i) => (
                    <Typography Typography variant="subtitle2" gutterBottom>
                      {i.description} {i.price}
                    </Typography>
                  ))} */}
                </Box>
                <Box>
                  <TripBookingModal
                    initialData={e}
                    reFreshData={props.reFreshData}
                  />
                </Box>
                <Box>
                  <InvoiceModal tripData={e} />
                </Box>
              </Stack>
            </Card>
          ))}
      </Stack>
    );
  return (
    <Stack sx={{ width: "100%", height: `calc(100vh - 260px)` }}>
      <div>
        <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
          <InputLabel id="e-select-standard-label"></InputLabel>
          <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            value={selectedDate}
            onChange={(e) => {
              setSelectedDate(e.target.value);
            }}
          >
            <MenuItem value={"Upcoming"}>{"Upcoming"}</MenuItem>

            <MenuItem value={"All"}>{"All"}</MenuItem>

            {dates.map((e) => (
              <MenuItem key={e} value={e}>
                {e.slice(5, 10)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      {toRenderBooking}
    </Stack>
  );
};

export default TripBookedEvent;
